export const INVITE_URL = `https://dashboard.joinally.co/invite`;
